import React from 'react';
import { motion } from 'framer-motion';

const SectionHeading = ({
  eyebrow,
  title,
  description,
  align = 'center', // 'left' | 'center'
  className = '',
  titleColor = 'white',
  descriptionColor = ''
}) => {
  const alignmentClasses = {
    center: 'text-center mx-auto',
    left: 'text-left'
  };
  const descriptionColoor = descriptionColor ? `text-${descriptionColor}` : 'text-muted-foreground';
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className={`max-w-3xl mb-12 md:mb-16 ${alignmentClasses[align]} ${className}`}
      data-testid="section-heading"
    >
      {eyebrow && (
        <p 
          className="text-brand-maroon font-semibold text-sm uppercase tracking-wider mb-3"
          data-testid="section-eyebrow"
        >
          {eyebrow}
        </p>
      )}
      <h2 
        className={`text-3xl md:text-4xl lg:text-5xl font-bold text-${titleColor} mb-4`}
        data-testid="section-title"
      >
        {title}
      </h2>
      {description && (
        <p 
          className={`text-lg ${descriptionColoor} leading-relaxed `}
          data-testid="section-description"
        >
          {description}
        </p>
      )}
    </motion.div>
  );
};

export default SectionHeading;